import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { Loader2, Save } from 'lucide-react';
import PropertySetupForm from './PropertySetupForm';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function PropertyDetailsDialog({ open, onClose, inspection, onSuccess }) {
  const { token } = useContext(AuthContext);
  const [propertyDetails, setPropertyDetails] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && inspection) {
      // Initialize with existing property details or empty object
      setPropertyDetails(inspection.property_details || {});
    }
  }, [open, inspection]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(
        `${API}/inspections/${inspection.id}`,
        { property_details: propertyDetails },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Property details saved successfully');
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error('Failed to save property details:', error);
      toast.error('Failed to save property details');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-5xl max-h-[95vh] flex flex-col overflow-hidden" data-testid="property-details-dialog">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle>Edit Property Details</DialogTitle>
          <DialogDescription>
            {inspection?.property_address}
          </DialogDescription>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto -mx-6 px-6 min-h-0">
          <PropertySetupForm 
            propertyDetails={propertyDetails}
            onChange={setPropertyDetails}
          />
        </div>

        <div className="flex justify-end gap-2 pt-4 border-t mt-4">
          <Button type="button" variant="outline" onClick={onClose} data-testid="cancel-btn">
            Cancel
          </Button>
          <Button type="button" onClick={handleSave} disabled={saving} data-testid="save-btn">
            {saving ? (
              <Loader2 className="h-4 w-4 animate-spin mr-2" />
            ) : (
              <Save className="h-4 w-4 mr-2" />
            )}
            Save Property Details
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
